import { Switch, Route, useLocation } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { HelmetProvider } from "react-helmet-async";
import Home from "@/pages/home";
import Landing from "@/pages/landing";
import About from "@/pages/about";
import EmotionSearch from "@/pages/emotion-search";
import EmotionTheme from "@/pages/emotion-theme";
import EmotionIndex from "@/pages/emotion-index";
import NotFound from "@/pages/not-found";
import PrivacyPolicy from "@/pages/privacy-policy";
import HubPage, { HubIndexPage } from "@/pages/hub";
import { useEffect } from "react";
import { initGA } from "./lib/analytics";
import { useAnalytics } from "./hooks/use-analytics";
import { initializeRouting } from "./lib/hydration";

function ScrollToTop() {
  const [location] = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return null;
}

function Router() {
  // Track page views when routes change
  useAnalytics();
  
  return (
    <>
      <ScrollToTop />
      <Switch>
      <Route path="/" component={Landing} />
      <Route path="/artwork/:id" component={Home} />
      <Route path="/about" component={About} />
      <Route path="/emotion-search" component={EmotionSearch} />
      <Route path="/emotion-search/:id" component={EmotionSearch} />
      <Route path="/emotion" component={EmotionIndex} />
      <Route path="/emotion/:theme" component={EmotionTheme} />
      <Route path="/privacy-policy" component={PrivacyPolicy} />
      <Route path="/artists">{() => <HubIndexPage kind="artist" />}</Route>
      <Route path="/styles">{() => <HubIndexPage kind="style" />}</Route>
      <Route path="/artist/:slug">{() => <HubPage kind="artist" />}</Route>
      <Route path="/style/:slug">{() => <HubPage kind="style" />}</Route>
      <Route path="/museums">{() => <HubIndexPage kind="museum" />}</Route>
      <Route path="/museum/:slug">{() => <HubPage kind="museum" />}</Route>
<Route component={NotFound} />
    </Switch>
    </>
  );
}

function App() {
  // Initialize Google Analytics and routing when app loads
  useEffect(() => {
    initGA();
    initializeRouting();
  }, []);

  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
